import {
	KeyIcon
} from '@heroicons/vue/24/outline'
import {
	Nav
} from '@/types'

export const nav: Nav = { 
    name: 'Licensing', 
    to: {name: 'Licensing'}, 
    icon: KeyIcon, 
    position: 2,
    show: true,
	module: "licensing"
}
